module.exports = __webpack_public_path__ + "static/transfer_money.2fa8d14c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/transfer_money.png
// module id = 714
// module chunks = 154382131621592